<div class="grid layout">
  <div class="col-9 md:col-12 lg:col-12">
    <h1>
      ¡Vamos a crear tu asistente!<img
        src="/assets/icons/shine.svg"
        class="shine-icon"
        alt="shine"
        style="height: 1.2em; vertical-align: middle; margin-left: 15px"
      />
    </h1>
  </div>
  <div class="col-12 md:col-12 lg:col-6" style="margin-bottom: 22px">
    <p>Estos son los pasos que seguiremos:</p>
  </div>
  <ul [ngClass]="isMobile ? 'col-12' : ''" style="margin: 0px">
    <li *ngFor="let event of events" class="grid">
      <div class="col-1">
        <span
          [style.backgroundColor]="event.color"
          style="width: 1.5rem; height: 1.5rem"
          class="flex z-1 align-items-center justify-content-center text-white border-circle shadow-2"
        >
          <i [ngClass]="event.icon" class="customIcon"></i>
        </span>
      </div>
      <div class="col-10">
        <h4 style="margin-bottom: 0.8rem">{{ event.status }}</h4>
        <p class="list" style="margin-top: 0px">{{ event.text }}</p>
      </div>
    </li>
  </ul>
  <div *ngIf="!isMobile">
    <div style="position: absolute; bottom: 1vh; right: 150px; text-align: right">
      <globot-button
        [text]="'Empecemos'"
        width="w-auto"
        [icon]="'pi pi-arrow-right'"
        [iconPosition]="'right'"
        (clickEvent)="next()"
        class="box-button"
      ></globot-button>
    </div>
    <br />
    <div style="position: absolute; bottom: 1vh; left: 50px">
      <globot-button
        class="col-12"
        *ngIf="haveBot"
        [text]="'Volver a mis asistentes'"
        [icon]="'pi pi-arrow-left'"
        width="w-auto"
        [iconPosition]="'left'"
        [styleClass]="'secondary'"
        (clickEvent)="back()"
        class=""
      >
      </globot-button>
    </div>
  </div>
  <div style="width: 90vw" *ngIf="isMobile">
    <globot-button
      [text]="'Empecemos'"
      width="w-100"
      [icon]="'pi pi-arrow-right'"
      [iconPosition]="'right'"
      (clickEvent)="next()"
      class="box-button"
    ></globot-button>
    <br />
    <globot-button
      class="col-12"
      *ngIf="haveBot"
      [text]="'Volver a mis asistentes'"
      width="w-100"
      [iconPosition]="'left'"
      [styleClass]="'secondary'"
      (clickEvent)="back()"
      class="box-button"
    >
    </globot-button>
  </div>
</div>
